import styled from 'styled-components';
import { colors } from 'app/variables';
import { media } from 'app/utils/style';

export const Container = styled.div`
  display: none;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
  height: 100%;

  ${media.mediumDesktop`
    display: flex;
  `}
`;
export const Name = styled.div`
  line-height: 2rem;
  font-size: 2.25rem;
  font-weight: 600;
`;
export const TimeSpan = styled.div`
  line-height: 1.5rem;
  font-size: 1.5rem;
  font-weight: 500;
`;
export const InfoBlockContainer = styled.div`
  display: none;
  flex-direction: column;
  gap: 2.5rem;
  padding-right: 1.5rem;

  ${media.mediumDesktop`
    display: flex;
  `}
`;
export const MainInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
export const Label = styled.div`
  color: ${colors.dustyGray};
  min-width: 120px;
  text-align: left;
  display: none;
  ${media.mediumHigh`
    display: block;
  `}
`;
export const SecondaryInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-right: 1rem;
`;
export const SecondaryInfoBlock = styled.div`
  display: flex;
  flex-direction: row;
`;
